import type * as THREE from "three";

const contextLostCheckInProgress: THREE.WebGLRenderer[] = [];

export function checkWebGLContextLost(renderer: THREE.WebGLRenderer, error: any, errorMsgPrefix: string) {
  if (contextLostCheckInProgress.includes(renderer)) {
    return;
  }
  contextLostCheckInProgress.push(renderer);
  renderer.getContext().finish();
  console.error(`${errorMsgPrefix} Checking if WebGL context is still valid.`);
  function checkContextLost() {
    const contextLost = renderer.getContext().isContextLost();
    console.error(
      errorMsgPrefix +
        (contextLost ? " WebGL context is lost" : " WebGL context is still valid according to the browser"),
    );
    if (!contextLost) {
      throw error;
    }
  }
  // Checking context lost status immediately is not reliable, since the status is communicated asynchronously. Wait for 200 ms before checking the error.
  setTimeout(checkContextLost, 200);
}
